import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoFilialesAgregarComponent {
  constructor($catalogos, $filter) {
    this.$catalogos = $catalogos
    this.orderBy = $filter('orderBy')
    this.filterBy = $filter('filter')
    this.data = undefined
    this.onAgregar = undefined
    this.onCancelar = undefined
  }

  $onInit() {
    this.filtro = ''
    this.clientes = undefined
    this.agregados = undefined
    this.resultados = undefined
    this.agregando = false

    return this.$catalogos.get('clientes')
      .then((data) => {
        this.agregados = this.data.map((item) => item.ID_Cliente)
        this.clientes = this.orderBy(data.filter((item) => this.agregados.indexOf(item.ID_Cliente) < 0), 'Nombre')

        this.filtrar()
      })
  }

  agregar(item) {
    let data = {
      ID_Cliente: item.ID_Cliente,
      Master: this.agregados.length === 0,
      Nombre: item.Nombre,
    }

    this.onAgregar({$event: {data: data}})
  }

  filtrar() {
    this.resultados = this.filterBy(this.clientes, this.filtro)
  }
}

module.component('fanProyectoFilialesAgregar', {
  controller: FanProyectoFilialesAgregarComponent,
  template: template,
  bindings: {
    data: '<',
    onAgregar: '&',
    onCancelar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/filiales/agregar/component.js